import { render, staticRenderFns } from "./PurcharseReceiptReject.vue?vue&type=template&id=29b10ba0&scoped=true&"
import script from "./PurcharseReceiptReject.vue?vue&type=script&lang=js&"
export * from "./PurcharseReceiptReject.vue?vue&type=script&lang=js&"
import style0 from "./PurcharseReceiptReject.vue?vue&type=style&index=0&id=29b10ba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b10ba0",
  null
  
)

export default component.exports